import { configure, getPreferences, onPreferencesChanged } from 'cookie-though';
import type { Config, CookiePreferences } from 'cookie-though/dist/types/types';
import { create } from 'zustand';

export interface CookiesStore {
  preferences?: CookiePreferences;
  isInitialized?: boolean;
  configure: (configuration: Config) => void;
  setPreferences: (preferences: CookiePreferences) => void;
}

export const useCookiesStore = create<CookiesStore>()((set, get) => ({
  setPreferences: (preferences) => set({ preferences }),
  configure: (config) => {
    configure(config);

    if (!get().isInitialized) {
      set({ isInitialized: true, preferences: getPreferences() });
      onPreferencesChanged((preferences) => set({ preferences }));
    }
  },
}));
